<template>
  <!-- skuId/skuImportId 详情 -->
  <div v-loading="productDetailIng" class="product-detail">
    <el-form ref="productDetailForm" class="prudoct-form" :model="productDetailForm" label-width="220px">
      <div class="box">
        <h2 class="title">基本信息</h2>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品名称：" label-width="189px">
              <span>{{ productDetailForm.skuName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="品牌：">
              <span>{{ productDetailForm.brandName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税率(%)：">
              <span>{{ productDetailForm.taxRateId | taxRateFilter(taxList) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属分类：">
              <span>{{ productDetailForm.categoryName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市场公开价(元)：">
              <span>{{ productDetailForm.price }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计量单位：">
              <span>{{ productDetailForm.unitValue }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起订量：">
              <span>{{ productDetailForm.minOrderQuantity }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="库存：">
              <span>{{ productDetailForm.skuStock }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交货期：">
              <span>{{ formatDeliverType(productDetailForm.deliveryType) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发货周期(天)：">
              <span>{{ productDetailForm.deliverTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单是否确认：">
              <span>
                {{ productDetailForm.isConfirm === 1 ? '是' : productDetailForm.isConfirm === 0 ? '否' : '' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品编号：">
              <span>{{ productDetailForm.skuCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日期：">
              <span>{{ productDetailForm.updateTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="sub-title">属性</div>
        <el-row>
          <el-col v-for="(item, index) of productDetailForm.specificationArr" :key="index" :span="12">
            <el-form-item :label="item.attributeName + '：'">
              <span>{{ item.attributeValue }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="sub-title">规格</div>
        <el-row>
          <el-col v-for="(item, index) of productDetailForm.attrArr" :key="index" :span="12">
            <el-form-item :label="item.attributeName + '：'">
              <span>{{ item.attributeValue }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="box">
        <h2 class="title">商品销售规则</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label="销售范围：" class="p-relative">
              <span>
                {{
                  productDetailForm.salesScope === 1 ? '全平台' : productDetailForm.salesScope === 2 ? '仅协议客户' : ''
                }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="可售区域设置：">
              <span>{{ productDetailForm.salesScopeId | areaFilter(areaArr) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" label-width="189px">
              <span style="word-break: break-all; word-wrap: break-word">
                {{ productDetailForm.remark }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件：">
              <file-upload
                :upload-url="uploadUrl"
                :url="pdfFileList"
                accept=".pdf"
                :limit="10"
                :is-p-d-f="true"
                :file-size="20"
                :if-upload-btn="false"
              >
                <template #message>最多上传 10个文件，仅限 PDE 格式，文件大小不能超过 20M</template>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="box">
        <h2 class="title">商品图片</h2>
        <div class="sub-title">
          <span>商品图片</span>
          至少上传一张，最多5张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片：">
              <ul v-if="imageUrls.length" class="el-upload-list el-upload-list--picture-card new-img-list">
                <li v-for="(item, index) in imageUrls" :key="index" class="el-upload-list__item">
                  <img :src="item" alt class="el-upload-list__item-thumbnail" />
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="sub-title">
          <span>商品详情图片</span>
          至少上传一张，最多5张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <!-- <div v-if="productDetailForm.systemSign !== 2" class="img-delail">
          <img v-for="(item, index) in detailImageUrls" :key="index" :src="item" alt />
        </div>
        <div v-else v-html="detailImageUrls[0]"></div> -->

        <div v-if="systemSign === 2" v-html="importHtml"></div>

        <div v-else class="img-delail">
          <img v-for="(item, index) in productsDetailList" :key="index" :src="item.url" alt />
        </div>
      </div>
    </el-form>
    <div class="submit-button">
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import api from '../../../api/product';
// import MultiImageUpload from './multiImageUpload.vue'
import FileUpload from './fileUpload.vue';
import mixin from './mixin';

export default {
  name: 'ProductDetail',
  components: {
    // ElImageViewer,
    // MultiImageUpload,
    FileUpload,
  },
  mixins: [mixin],
  props: {
    productAuditId: {
      type: Number,
      default: 0,
    },
    skuId: {
      type: Number,
      default: 0,
    },
    ifEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      systemSign: '',
      importHtml: '',
      uploadUrl: api.fileUploadForProductFile,
      pdfFileList: [],
      productDetailForm: {
        // 商品名称
        skuName: '',
        // 品牌
        brandName: '',
        // 税率
        taxRateValue: '',
        // 计量单位
        unitValue: '',
        // 市场公开价
        price: '',
        // 库存
        skuStock: '',
        // 起订量
        minOrderQuantity: '',
        // 订单是否确认
        isConfirm: '',
        // 发货周期
        deliverTime: '',
        deliveryType: '',
        // 可售区域设置
        salesScopeId: '',
        // 备注
        remark: '',
        // 附件列表
        skuFiles: [],
        // 主图
        imageUrls: [],
        // 详情图
        detailImageUrls: [],
        imageUrlsExist: [],
        detailImageUrlsExist: [],
        updateTime: '',
      },
      imageUrls: [],
      detailImageUrls: [],
      productsDetailList: [],
      showImgViewer: false,
      productDetailIng: true,
    };
  },
  created() {
    this.productAuditId && this.getAuditProductDetail(this.productAuditId);
    this.skuId && this.getMaintainProductDetail(this.skuId);
  },
  methods: {
    goBack() {
      const { currentIndex } = this.$route.query;
      if (currentIndex) {
        this.$router.push({
          path: '/goodsMaintenance',
          query: {
            currentIndex,
          },
        });
        return;
      }
      this.$router.go(-1);
    },
    isHtmIFragment(str) {
      // HTML标记的开始和结束标志
      const startTag = /<[>]+>/;
      // ·如果字符串包含了HTML标记，并且不只有单个标记 (比如“<dif (startTag.test(str)) {
      if (str && (startTag.test(str) || !str.startsWith('http'))) {
        return true;
      }
      return false;
    },
    // 获取维护商品-上下架的详情
    async getMaintainProductDetail(skuId) {
      const { querySkuInfoForEdite } = api;
      try {
        this.productDetailIng = true;
        const res = await querySkuInfoForEdite({ skuId });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.skus[0];
          // 规格 specification
          Object.assign(data, data.skuContentObject);
          const specificationArr = res.data?.attributes;
          const attrArr = data.attributes;
          data.attrArr = attrArr;
          data.specificationArr = specificationArr;
          // detailImageUrlsExist: [];
          const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist];
          /* for (let item of imageUrlsArr) {
            this.productsList.push({ name: "xxx.pgn", url: item });
          } */

          const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist];

          this.pdfFileList = data.skuFiles ? data.skuFiles : res.data.skuFiles;
          console.log(this.pdfFileList, 'this.pdfFileListthis.pdfFileListthis.pdfFileList');

          const detailContent = res.data.skus[0].detailImageUrls[0];
          // 判断是否是外部引入HTML
          if (this.isHtmIFragment(detailContent)) {
            this.systemSign = 2;
            this.importHtml = res.data.skus[0].detailImageUrls[0] ? res.data.skus[0].detailImageUrls[0] : '';
          } else {
            const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
            const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
            const detailImageUrlsArr = [...detailImageUrls, ...detailImageUrlsExist];
            for (const item of detailImageUrlsArr) {
              this.productsDetailList.push({ name: 'xxx.pgn', url: item });
            }
          }
          this.productDetailForm = { ...data };
          console.log(this.productDetailForm);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取维护/发布商品-审核的详情
    async getAuditProductDetail(productAuditId) {
      const { queryReleaseProductInfoById } = api;
      try {
        this.productDetailIng = true;
        const res = await queryReleaseProductInfoById({ productAuditId });
        this.productDetailIng = false;
        if (res.code === '200') {
          const { updateTime } = res.data;
          const data = res.data?.productVO?.skus[0];

          const detailContent = res.data.productVO.skus[0].detailImageUrls[0];
          // 判断是否是外部引入HTML
          if (this.isHtmIFragment(detailContent)) {
            this.systemSign = 2;
            this.importHtml = res.data.productVO.skus[0].detailImageUrls[0]
              ? res.data.productVO.skus[0].detailImageUrls[0]
              : '';
          } else {
            const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
            const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
            const detailImageUrlsArr = [...detailImageUrls, ...detailImageUrlsExist];
            for (const item of detailImageUrlsArr) {
              this.productsDetailList.push({ name: 'xxx.pgn', url: item });
            }
          }

          this.pdfFileList = data.skuFiles ? data.skuFiles : res.data.productVO.skuFiles;
          const specificationArr = res.data?.productVO.attributes;
          const attrArr = data.attributes;
          data.attrArr = attrArr;
          data.specificationArr = specificationArr;
          data.skuCode = res.data.skuCode;
          this.productDetailForm = { ...data };
          this.productDetailForm.salesScope = data.salesScope ? data.salesScope : res.data.productVO.salesScope;
          /* this.productDetailForm.taxRateValue = data.taxRateValue
            ? data.taxRateValue
            : res.data.productVO.taxRateValue; */
          this.productDetailForm.taxRateId = data.taxRateId ? data.taxRateId : res.data.productVO.taxRateId;
          this.productDetailForm.salesScopeId = data.salesScopeId ? data.salesScopeId : res.data.productVO.salesScopeId;
          this.productDetailForm.brandId = data.brandId ? data.brandId : res.data.productVO.brandId;
          this.productDetailForm.brandName = data.brandName ? data.brandName : res.data.productVO.brandName;
          this.productDetailForm.categoryId = data.categoryId ? data.categoryId : res.data.productVO.categoryId;
          this.productDetailForm.categoryName = data.categoryName ? data.categoryName : res.data.productVO.categoryName;
          this.productDetailForm.productId = data.productId ? data.productId : res.data.productVO.productId;
          this.productDetailForm.remark = data.remark ? data.remark : res.data.productVO.remark;
          this.productDetailForm.updateTime = updateTime;
          const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist];

          const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist];
          console.log(this.detailImageUrls);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 打开图片查看器
    openImgViewer(file) {
      // 获取要查看的图片临时地址
      this.imgPreviewList = [file.url];
      // 显示图片查看器
      this.showImgViewer = true;
    },
    // 关闭图片查看器
    closeImgViewer() {
      this.showImgViewer = false;
    },
    formatDeliverType(type) {
      console.log(type);
      return type != undefined && type != null ? (type === 2 ? '期货' : '现货') : '现货';
    },
  },
};
</script>
<style lang="scss" scoped>
.product-detail {
  color: #333;
  .box {
    padding: 20px 20px 0 20px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      padding-bottom: 20px;
    }
  }

  .prudoct-form {
    ::v-deep .el-form-item__content {
      width: 100%;
      margin-left: 0 !important;
      line-height: 1;
    }
    ::v-deep .el-form-item__label {
      font-size: 14px;
      line-height: 1;
    }
    ::v-deep .el-form-item {
      margin-bottom: 20px;
      line-height: 1;
      display: flex;
    }
  }
  .title {
    width: 100%;
    line-height: 1;
    font-size: 16px;
    margin-bottom: 18px;
    color: #000;
  }
  .sub-title {
    line-height: 40px;
    font-size: 14px;
    margin-bottom: 20px;
    background: #f5f5f5;
    padding-left: 20px;
  }
  .img-desc {
    padding: 0 0 6px 40px;
    font-size: 12px;
    line-height: 22px;
    margin-top: -10px;
    border-bottom: 1px solid #eee;
  }
  .upload-img {
    margin: 18px 118px;
  }
  .el-select {
    width: 100%;
  }

  .p-relative {
    position: relative;
    .icon {
      position: absolute;
      right: -30px;
      top: 5px;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 50%;
      background: red;
    }
  }
  .hideRemove ::v-deep .el-upload-list__item-delete {
    display: none !important;
  }
  .hideRemove ::v-deep .el-upload--picture-card {
    display: none !important;
  }
  .img-delail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      max-width: 100%;
    }
  }
  .submit-button {
    margin: 20px 0 30px 0;
    text-align: center;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
    }
  }
}
</style>
